import React, { useContext, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { GeneralContext } from '../../shared/contexts/GeneralContext.context';
import { getCookie } from '../../shared/helpers/cookies';

function LoginCallback() {
  const { loginAmos, isLogged } = useContext(GeneralContext);
  const navigate = useNavigate();

  const inFlightRef = useRef(false);
  const doneRef = useRef(false);

  useEffect(() => {
    if (!isLogged || inFlightRef.current || doneRef.current) return;

    inFlightRef.current = true;

    const handleCallback = async () => {
      try {
        const userEmail = localStorage.getItem('userData');
        if (userEmail?.length > 0) {
          localStorage.removeItem('userData');
        }

        const isGenericDomain =
          window.location.hostname === import.meta.env.VITE_DOMAIN_GENERIC;
        const oldPath = localStorage.getItem('oldPath');

        await loginAmos();

        if (isGenericDomain) {
          const userAuthRaw = getCookie('userAuth');
          let userAuth = {};
          try {
            userAuth = userAuthRaw ? JSON.parse(userAuthRaw) : {};
          } catch (_err) {
            userAuth = {};
          }

          if (userAuth?.email_verified === false) {
            navigate('/', { replace: true });
            doneRef.current = true;
            return;
          }

          navigate(
            userAuth?.isRegisteredAmos ? '/user' : '/lets-start?type=user',
            { replace: true }
          );
          doneRef.current = true;
          return;
        }

        if (oldPath?.length > 0) {
          navigate(oldPath, { replace: true });
          localStorage.removeItem('oldPath');
        } else {
          navigate('/', { replace: true });
        }

        doneRef.current = true;
      } finally {
        inFlightRef.current = false;
      }
    };

    handleCallback();
  }, [isLogged, navigate, loginAmos]);

  return <></>;
}

export default LoginCallback;
